/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

const Icon = ({ theme, color }) => <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M8.00002 1.77991C6.29006 1.77991 4.90002 3.16994 4.90002 4.87991C4.90002 6.58987 6.29006 7.97991 8.00002 7.97991C9.70999 7.97991 11.1 6.58987 11.1 4.87991C11.1 3.16994 9.70999 1.77991 8.00002 1.77991ZM5.90002 4.87991C5.90002 3.72223 6.84234 2.77991 8.00002 2.77991C9.15771 2.77991 10.1 3.72223 10.1 4.87991C10.1 6.03759 9.15771 6.97991 8.00002 6.97991C6.84234 6.97991 5.90002 6.03759 5.90002 4.87991ZM6.10022 8.17981C4.44337 8.17981 3.10022 9.52296 3.10022 11.1798V14.6798C3.10022 14.956 3.32408 15.1798 3.60022 15.1798C3.87636 15.1798 4.10022 14.956 4.10022 14.6798V11.1798C4.10022 10.0752 4.99565 9.17981 6.10022 9.17981H9.90022C11.0048 9.17981 11.9002 10.0752 11.9002 11.1798V14.6798C11.9002 14.956 12.1241 15.1798 12.4002 15.1798C12.6764 15.1798 12.9002 14.956 12.9002 14.6798V11.1798C12.9002 9.52296 11.5571 8.17981 9.90022 8.17981H6.10022Z'
      fill={theme.colors[color]}/>
</svg>

Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
